<template>
<div>
    <div id="contents">
        <div class="contents_wrap">
            <!-- logout -->
            <div class="landing_item">
                <!-- contents_head -->
                <!-- breadcrumbs -->
                <!-- //breadcrumbs -->
                <h2 class="pg_title">Access Denied</h2>
                <!-- //contents_head -->
                <p>
                    <em>You are not allowed to access the page.</em>
                    <a href="javascript:" class="btn_blue" title="" @click="goHome">Go Home</a>
                </p>

            </div>
            <!-- //logout -->

        </div>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {

        };
    },
    methods: {
        goHome() {
            this.$router.push({
                path: '/',
            });
        },
    },
    
}
</script>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/certificate/CertAccessDenied.vue